// §4.4 partial — admin/payments routes.
// Covers: /admin/payments, /admin/payments/pending
// (10/07/2026: rota de detalhe removida — a fila é a superfície inteira.)
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const PendingPaymentsPage = lazyWithRetry(
  () => import("./pages/PendingPaymentsPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/payments", Component: PendingPaymentsPage },
      { path: "/admin/payments/pending", Component: PendingPaymentsPage },
    ],
  },
];

export default routes;
